(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
